import type { InventoryScenarioAnalysisItem } from '@toggle/toggle';

// Matches a dotted snake ("tag.field"); excludes supplied-events rows which
// lead with a count instead (e.g. "Scenario: 12 supplied events…").
const LEADING_SNAKE = /^Scenario:\s*([\w-]+(?:\.[\w-]+)+)/i;

export const scenarioEntityTag = (description: string): string | undefined => {
  const snake = description.match(LEADING_SNAKE)?.[1];
  return snake ? snake.split('.')[0] : undefined;
};

export const resolveScenarioEntityTag = (
  scenarioItem: Pick<InventoryScenarioAnalysisItem, 'description' | 'entity'>
): string | undefined =>
  scenarioItem.entity ?? scenarioEntityTag(scenarioItem.description);

export const formatScenarioDescription = (
  description: string,
  entityName?: string
): string => {
  if (!entityName || !LEADING_SNAKE.test(description)) {
    return description;
  }

  return description.replace(LEADING_SNAKE, () => entityName);
};
